module.exports = __webpack_public_path__ + "static/media/stofferingen-34.7cd8f2cd.jpg";